import { Component, OnInit, Inject, PLATFORM_ID, OnDestroy, ViewChild, ElementRef } from '@angular/core'
import { SharedService } from '@flowaccount/landing'
import { TranslateService } from '@ngx-translate/core'
//import { ActivatedRoute, Params } from '@angular/router'
import { Title } from '@angular/platform-browser'
import { SEOService } from '@flowaccount/landing'
//import { isPlatformBrowser } from '@angular/common'
import { Subscription } from 'rxjs'
import { isScullyRunning } from '@scullyio/ng-lib'

declare const gaTrackEvent
@Component({
  selector: 'flowaccount-contactus',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.scss'],
})
export class ContactusComponent implements OnInit, OnDestroy {
  @ViewChild('contactForm', { static: true })
  contactForm: ElementRef
  public language
  scullyRunning = false
  displayCaptcha = false
  captchaResponseId = ''
  protected langchangeSubscription: Subscription

  constructor(
    public sharedService: SharedService,
    private _translate: TranslateService,
    public translate: TranslateService,
    //@Inject(PLATFORM_ID) private platformId: Object,
    //private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private seoService: SEOService,
  ) {
    this.setMeta()
    this.langchangeSubscription = this._translate.onLangChange.subscribe(event => {
      this.setMeta()
    })
    this.scullyRunning = isScullyRunning()
  }

  setMeta() {
    this.titleService.setTitle(this.translate.instant('metatitle-Contactus'))
    this.seoService.createMetaTag(this.translate.instant('metatitle-Contactus'), this.translate.instant('metaDescription'))
    this.seoService.createOg(
      'https://flowaccountcdn.com/images/Thumnail_FlowPayroll_FlowAccount.png',
      this.translate.instant('metatitle-Contactus'),
      this.translate.instant('metaDescription'),
    )
  }

  ngOnInit(): void {
    this.displayCaptcha = true
  }
  ngOnDestroy() {
    this.langchangeSubscription.unsubscribe()
  }
  trackEvent(category, action, label) {
    gaTrackEvent(category, action, label)
  }

  isEmail(email) {
    const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/
    return regex.test(email)
  }

  public submitContact() {
    let isValid = true

    // let $nativeElement = $(this.nativeElement);
    const $contactForm = this.contactForm.nativeElement
    const hasError = $contactForm.querySelector('.has-error')
    if (hasError) {
      hasError.classList.remove('has-error')
    }
    const name = $contactForm.querySelector('#name')
    const phone = $contactForm.querySelector('#phone')
    const email = $contactForm.querySelector('#email')
    const message = $contactForm.querySelector('#message')

    if (message.value.trim() === '') {
      isValid = false
      message.parentNode.classList.add('has-error')
      message.parentNode.querySelector('.lbl-valid').classList.remove('hidden')
      message.focus()
    }

    const intRegexPhone = /[0-9 -()+]+$/
    if (phone.value.trim() === '') {
      isValid = false
      phone.parentNode.classList.add('has-error')
      phone.focus()
    } else {
      if (phone.value.trim().length < 6 || !intRegexPhone.test(phone.value.trim())) {
        isValid = false
        phone.parentNode.classList.add('has-error')
        phone.focus()
      }
    }

    if (email.value.trim() === '') {
      isValid = false
      email.parentNode.classList.add('has-error')
      email.parentNode.querySelector('.lbl-valid').classList.remove('hidden')
      email.focus()
    } else if (!this.isEmail(email.value.trim())) {
      isValid = false
      email.parentNode.classList.add('has-error')
      email.parentNode.querySelector('.lbl-valid').classList.remove('hidden')
      email.focus()
    }

    if (name.value.trim() === '') {
      isValid = false
      name.parentNode.classList.add('has-error')
      name.parentNode.querySelector('.lbl-valid').classList.remove('hidden')
      name.focus()
    }
    if (isValid) {
      name.parentNode.querySelector('.lbl-valid').classList.add('hidden')
      email.parentNode.querySelector('.lbl-valid').classList.add('hidden')
      message.parentNode.querySelector('.lbl-valid').classList.add('hidden')
    }

    return this.captchaResponseId !== '' ? isValid : (isValid = false)
  }
  public resolved(captchaResponse: string) {
    console.log(`Resolved captcha with response: ${captchaResponse}`)
    this.captchaResponseId = captchaResponse
  }
}
